import { Component } from 'react';

/** Stops a crashed route from leaving a blank white main pane. */
export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      const message = this.state.error?.message || String(this.state.error);
      const wrap = this.props.fullPage
        ? 'min-h-screen bg-gray-50 p-6 lg:p-10'
        : '';
      return (
        <div className={wrap}>
          <div className="rounded-lg border border-red-200 bg-white p-6 shadow-sm max-w-xl">
            <h2 className="text-lg font-semibold text-red-800">This page failed to load</h2>
            <p className="mt-2 text-sm text-gray-700">
              Reload, or go back. If it keeps happening, copy the message below.
            </p>
            <pre className="mt-3 max-h-40 overflow-auto rounded bg-red-50 p-3 text-xs text-red-900 whitespace-pre-wrap">
              {message}
            </pre>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                type="button"
                className="rounded-lg bg-navy-900 px-4 py-2 text-sm font-medium text-white hover:bg-navy-800"
                onClick={() => this.setState({ error: null })}
              >
                Try again
              </button>
              <a
                href="/buildings"
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50"
              >
                Back to Buildings
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
